// extracted by mini-css-extract-plugin
module.exports = {"gameModeTooltip":"GameModeTooltip_gameModeTooltip__3Qpzr","content":"GameModeTooltip_content__oQIw4"};